export default "__VITE_ASSET__1a69fcf8__"